import React, { memo } from 'react'
import { Text } from 'react-native'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import { customerStatus } from '@linqpal/models/src/dictionaries/customerStatus'
import { Container } from './Container'
import startCase from 'lodash/startCase'
import { commonColors } from '@linqpal/common-frontend/src/theme'
/**
 * Status Badge colored based on status of invitation status.
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
type PropType = {
  status?: string
  style?: typeof composeStyle
}
export const InvitationStatusBadge = memo(
  ({ status = customerStatus.saved, style }: PropType) => {
    const backgroundStatusColors = {
      [customerStatus.saved]: commonColors.statusOther,
      [customerStatus.inActive]: commonColors.statusOther,
      [customerStatus.invited]: commonColors.statusOther,
      [customerStatus.active]: commonColors.statusActive,
      [customerStatus.tradeCredit]: commonColors.statusActiveCredit,
      [customerStatus.inHouseCredit]: commonColors.statusActiveCredit,
    }

    return (
      <Container minified>
        <Text
          style={composeStyle(
            {
              color: backgroundStatusColors[status],
              paddingVertical: 4,
              paddingHorizontal: 8,
              fontSize: 14,
              lineHeight: 16,
              fontWeight: (
                [customerStatus.tradeCredit, customerStatus.active] as string[]
              ).includes(status)
                ? 'bold'
                : '500',
              borderWidth: 0,
            },
            style,
          )}
        >
          {startCase(status.toLowerCase())}
        </Text>
      </Container>
    )
  },
)
